import { withInstall } from '@vuesax-alpha/utils'
import Pagination from './src/pagination'

export const VsPagination = withInstall(Pagination)
export default VsPagination

export * from './src/pagination'
